
import { react2angular } from 'react2angular';
import PisConditionsView from "./PisConditionsView";
// TODO webtip.module is needed for React to render for some reason - move to correct module
angular.module('webtip.module')
    .component('pisConditions', react2angular(PisConditionsView,[], ['$state', 'userService', 'stateService', 'toasterService', '$uibModal']));